module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "AFKE"
    }
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "JANUARY 4: Whistle While You Work"
    }
  }, [_c('h1', {
    staticClass: "chapter2",
    attrs: {
      "id": "pAI5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#AB_ch05",
      "id": "AB_cha05"
    }
  }, [_vm._v("JANUARY 4"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "chapter2a"
  }, [_vm._v("Whistle While You Work")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "ext",
    attrs: {
      "id": "pAYc"
    }
  }, [_c('em', [_vm._v("I know that there is nothing better for people than to be happy and to do good while they live. That each of them may eat and drink, and find satisfaction in all their toil—this is the gift of God.")])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pA7L"
    }
  }, [_vm._v("—Ecclesiastes 3:12–13 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NIV")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "Ays"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_c('b', [_vm._v("I")])]), _vm._v("f you have watched Disney’s classic film "), _c('em', [_vm._v("Snow White and the Seven Dwarfs")]), _vm._v(", you probably know the song “Whistle While You Work.” Even if you’ve never heard it, the song’s title is self-explanatory, and the lyrics flesh out its idea of choosing joy even while performing mundane tasks.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pACb"
    }
  }, [_vm._v("Snow White made it look simple, but this mind-set takes effort. It is all too easy to grumble and complain while working, whether you’re sweeping up your child’s Cheerios for the millionth time, sitting through a long meeting, studying for a big exam, or working long hours to finish a project. But when we gripe, we often find feelings of negativity following us for the rest of the day. If we decide to adopt a positive attitude or choose to figuratively whistle while working, we’ll find life much more enjoyable.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pALm"
    }
  }, [_vm._v("Consider whistling through work today, in whatever form is helpful to you. Listen to your favorite song to start your day. Savor your coffee during a tough drive to the office. Remind yourself of the good that’s coming from your work, whether it’s a clean and peaceful home, a paycheck to feed your family, or a step closer to your degree. Don’t grumble; whistle!")]), _vm._v(" "), _c('p', {
    staticClass: "left1",
    attrs: {
      "id": "pAYnH"
    }
  }, [_c('em', [_vm._v("Father, please remind me to choose a lighthearted response to the mundane tasks of the day.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9050da8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter05.vue
// module id = 81
// module chunks = 0